import { Navigate, Outlet } from "react-router-dom";
import { useUserProfile } from "@/hooks/useUserProfile";

export function AdminProtectedRoute() {
  const { session, profile, loading } = useUserProfile();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-navy border-t-transparent" />
      </div>
    );
  }

  // No session at all, fair to send to login.
  if (!session) return <Navigate to="/login" replace />;

  // Signed-in user with the wrong role: bounce them to THEIR home, not the
  // login page. Sending a logged-in customer to /login looks like a silent
  // sign-out (audit #30) and forces them to re-authenticate for no reason.
  if (profile?.role !== "lembra_admin") {
    if (profile?.role === "bakery") return <Navigate to="/bakery/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
